import useAncillaryCardsData from './useAncillaryCardsData';

export default useAncillaryCardsData;
